import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-283d74a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "outBox"
};
const _hoisted_2 = {
  class: "content-box-out"
};
const _hoisted_3 = {
  class: "content-box"
};
const _hoisted_4 = {
  class: "top"
};
const _hoisted_5 = {
  class: "top_left"
};
const _hoisted_6 = {
  class: "shipments"
};
const _hoisted_7 = {
  class: "selectBox"
};
const _hoisted_8 = {
  class: "areaBox"
};
const _hoisted_9 = {
  key: 0,
  class: "areaBox"
};
const _hoisted_10 = {
  key: 1,
  class: "areaBox"
};
const _hoisted_11 = {
  key: 2,
  class: "areaBox"
};
const _hoisted_12 = {
  class: "areaBox"
};
const _hoisted_13 = {
  class: "areaBox"
};
const _hoisted_14 = {
  class: "areaBox"
};
const _hoisted_15 = {
  class: "tip",
  style: {
    "background": "#b45a5a"
  }
};
const _hoisted_16 = {
  class: "tip",
  style: {
    "background": "#dfb229"
  }
};
const _hoisted_17 = {
  class: "tip",
  style: {
    "background": "#5ab46b"
  }
};
const _hoisted_18 = {
  class: "btnBox"
};
const _hoisted_19 = {
  class: "upload-box"
};
const _hoisted_20 = {
  class: "upload-box-title"
};
const _hoisted_21 = {
  class: "upload-box-title-text"
};
const _hoisted_22 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_23 = {
  class: "upload-box-dashed"
};
const _hoisted_24 = {
  class: "upload-icon-group-box"
};
const _hoisted_25 = {
  class: "el-upload__text"
};
const _hoisted_26 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_27 = {
  class: "progressBox"
};
const _hoisted_28 = {
  style: {
    "margin-right": "30px",
    "color": "#777",
    "font-size": "16.5"
  }
};
const _hoisted_29 = {
  class: "insTableBox"
};
const _hoisted_30 = {
  class: "rowBox"
};
const _hoisted_31 = {
  class: "expand-wrapper",
  style: {
    "box-shadow": "1px 2px 2px 1px #dedede"
  }
};
const _hoisted_32 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_33 = {
  class: "TipsBox"
};
const _hoisted_34 = {
  class: "tipsPopover"
};
const _hoisted_35 = {
  class: "_title"
};
const _hoisted_36 = {
  class: "info"
};
const _hoisted_37 = {
  class: "info"
};
const _hoisted_38 = {
  key: 0
};
const _hoisted_39 = {
  class: "TipsBox"
};
const _hoisted_40 = {
  class: "tipsPopover"
};
const _hoisted_41 = {
  class: "_title"
};
const _hoisted_42 = {
  class: "info"
};
const _hoisted_43 = {
  class: "info"
};
const _hoisted_44 = {
  class: "info"
};
const _hoisted_45 = {
  style: {
    "width": "100%",
    "height": "200px",
    "background": "#fff"
  }
};
const _hoisted_46 = {
  key: 1
};
const _hoisted_47 = {
  class: "TipsBox"
};
const _hoisted_48 = {
  class: "installation-progress"
};
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
  key: 1,
  style: {
    "color": "#777",
    "cursor": "not-allowed",
    "font-weight": "400"
  }
};
const _hoisted_51 = {
  class: "bottom-pagination-box"
};
const _hoisted_52 = {
  class: "content-box"
};
const _hoisted_53 = {
  class: "top"
};
const _hoisted_54 = {
  class: "top_left"
};
const _hoisted_55 = {
  class: "shipments"
};
const _hoisted_56 = {
  class: "selectBox"
};
const _hoisted_57 = {
  class: "areaBox"
};
const _hoisted_58 = {
  class: "areaBox"
};
const _hoisted_59 = {
  class: "areaBox"
};
const _hoisted_60 = {
  class: "areaBox"
};
const _hoisted_61 = {
  class: "areaBox"
};
const _hoisted_62 = {
  class: "btnBox"
};
const _hoisted_63 = {
  class: "upload-box"
};
const _hoisted_64 = {
  class: "upload-box-title"
};
const _hoisted_65 = {
  class: "upload-box-title-text"
};
const _hoisted_66 = {
  style: {
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_67 = {
  class: "upload-box-dashed"
};
const _hoisted_68 = {
  class: "upload-icon-group-box"
};
const _hoisted_69 = {
  class: "el-upload__text"
};
const _hoisted_70 = {
  style: {
    "font-size": "12px"
  }
};
const _hoisted_71 = {
  class: "progressBox"
};
const _hoisted_72 = {
  style: {
    "margin-right": "30px",
    "color": "#777",
    "font-size": "16.5"
  }
};
const _hoisted_73 = {
  class: "insTableBox"
};
const _hoisted_74 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_75 = {
  class: "TipsBox"
};
const _hoisted_76 = {
  class: "tipsPopover"
};
const _hoisted_77 = {
  class: "_title"
};
const _hoisted_78 = {
  class: "info"
};
const _hoisted_79 = {
  class: "info"
};
const _hoisted_80 = {
  class: "TipsBox"
};
const _hoisted_81 = {
  class: "tipsPopover"
};
const _hoisted_82 = {
  class: "_title"
};
const _hoisted_83 = {
  class: "info"
};
const _hoisted_84 = {
  class: "info"
};
const _hoisted_85 = {
  key: 0,
  class: "info"
};
const _hoisted_86 = {
  key: 0
};
const _hoisted_87 = ["onClick"];
const _hoisted_88 = {
  key: 0
};
const _hoisted_89 = {
  key: 1
};
const _hoisted_90 = {
  key: 2
};
const _hoisted_91 = {
  key: 1
};
const _hoisted_92 = {
  class: "TipsBox"
};
const _hoisted_93 = {
  class: "tipsPopover3"
};
const _hoisted_94 = {
  key: 1
};
const _hoisted_95 = {
  class: "bottom-pagination-box"
};
const _hoisted_96 = {
  class: "ex-dialog-title"
};
const _hoisted_97 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "overflow-y": "auto"
  }
};
const _hoisted_98 = {
  style: {
    "display": "flex",
    "justify-content": "end",
    "padding": "10px 0px"
  }
};
const _hoisted_99 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%"
  }
};
const _hoisted_100 = {
  key: 0,
  id: "container"
};
const _hoisted_101 = {
  key: 1,
  id: "panel",
  style: {
    "width": "100%",
    "height": "200px"
  }
};
const _hoisted_102 = {
  key: 2,
  class: "tipsPopover1"
};
const _hoisted_103 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_104 = {
  style: {
    "min-width": "135px"
  }
};
const _hoisted_105 = {
  style: {
    "min-width": "50px",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_106 = {
  style: {
    "width": "1px",
    "background-color": "#777777",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_107 = {
  key: 0,
  style: {
    "min-width": "12px",
    "height": "12px",
    "background-color": "white",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_108 = {
  key: 1,
  style: {
    "min-width": "8px",
    "height": "8px",
    "background-color": "white",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_109 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "min-width": "6px",
    "height": "6px",
    "background-color": "#777777",
    "border-radius": "50%"
  }
}, null, -1));
const _hoisted_110 = [_hoisted_109];
const _hoisted_111 = {
  style: {
    "margin-bottom": "10px",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_112 = {
  key: 0,
  style: {
    "font-size": "14px",
    "color": "black"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_down_circle_outlined = _resolveComponent("down-circle-outlined");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_cascader = _resolveComponent("a-cascader");
  const _component_a_input_search = _resolveComponent("a-input-search");
  const _component_a_button = _resolveComponent("a-button");
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_popover = _resolveComponent("el-popover");
  const _component_a_progress = _resolveComponent("a-progress");
  const _component_vxe_column = _resolveComponent("vxe-column");
  const _component_vxe_table = _resolveComponent("vxe-table");
  const _component_el_link = _resolveComponent("el-link");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_vxe_pager = _resolveComponent("vxe-pager");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_ex_dialog = _resolveComponent("ex-dialog");
  const _component_a_modal = _resolveComponent("a-modal");
  const _component_a_config_provider = _resolveComponent("a-config-provider");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_tabs, {
    activeKey: $setup.activeName,
    "onUpdate:activeKey": _cache[23] || (_cache[23] = $event => $setup.activeName = $event),
    type: "line",
    class: "tabs-card default-tabs",
    tabBarStyle: {
      background: '#f7f8ff'
    },
    animated: false
  }, {
    default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
      key: "first",
      tab: _ctx.$t('installConvey.installationProgress')
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.storeType,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.installQuery.insSelect.storeType = $event),
        placeholder: _ctx.$t('installConvey.selectStoreType'),
        size: "medium",
        onChange: _cache[1] || (_cache[1] = $event => $setup.searchInstallClick(1)),
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeTypeInstallationData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.storeTypeId,
            value: item.storeTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.storeTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "placeholder"])]), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_a_select, {
        disabled: $setup.vendorId.length > 0,
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.vendorId,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.installQuery.insSelect.vendorId = $event),
        placeholder: _ctx.$t('installConvey.selectSupplier'),
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendorData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.vendorId,
            value: item.vendorId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorName), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["disabled", "value", "placeholder", "onChange"])])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.vendorTypeId,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => $setup.installQuery.insSelect.vendorTypeId = $event),
        placeholder: _ctx.$t('installConvey.selectService'),
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendorTypeData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.vendor,
            value: item.vendorTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "placeholder", "onChange"])])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.installationStatusId,
        "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.installQuery.insSelect.installationStatusId = $event),
        placeholder: _ctx.$t('installConvey.selectInstallStatus'),
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.installationStatusData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.installationStatusId,
            value: item.installationStatusId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.installationStatusNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "placeholder", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createVNode(_component_a_cascader, {
        style: {
          "width": "150px"
        },
        value: $setup.installQuery.insSelect.provinceCity,
        "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.installQuery.insSelect.provinceCity = $event),
        options: $setup.provinceDictData,
        placeholder: _ctx.$t('installConvey.selectCity'),
        changeOnSelect: true,
        "expand-trigger": "hover",
        onChange: _cache[6] || (_cache[6] = $event => $setup.searchInstallClick(2))
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        _: 1
      }, 8, ["value", "options", "placeholder"])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.installQuery.insSelect.installationConfirmStatusId,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => $setup.installQuery.insSelect.installationConfirmStatusId = $event),
        placeholder: _ctx.$t('installConvey.selectAuditStatus'),
        size: "medium",
        onChange: $setup.searchInstallClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: "1"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("installConvey.unreviewed")), 1)]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "2"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("installConvey.partiallyReviewed")), 1)]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "3"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("installConvey.reviewed")), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["value", "placeholder", "onChange"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("installConvey.unreviewed")), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("installConvey.partiallyReviewed")), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("installConvey.reviewed")), 1)])]), _createElementVNode("div", null, [_createVNode(_component_a_input_search, {
        value: $setup.installQuery.insValue,
        "onUpdate:value": _cache[8] || (_cache[8] = $event => $setup.installQuery.insValue = $event),
        placeholder: _ctx.$t('installConvey.searchContent'),
        style: {
          "width": "264px"
        },
        onSearch: $setup.searchInstallClick
      }, null, 8, ["value", "placeholder", "onSearch"])])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
        visible: $setup.uploadInstallPopoverVisible,
        placement: "bottom",
        trigger: "click",
        width: "auto",
        teleported: false,
        "popper-class": "upload-box-popper"
      }, {
        reference: _withCtx(() => [$setup.permission.havePermission('安装及发货进度', '预约信息上传') ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "sts-button default",
          color: "black",
          onClick: $setup.openUploadInstallPopover,
          style: {
            "width": "100px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.appointmentUpload")), 1)]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("installConvey.appointmentUpload")), 1), _createVNode(_component_svg_icon, {
          iconName: "close",
          iconColor: 'black',
          iconSize: "15px",
          style: {
            "cursor": "pointer",
            "padding": "3px"
          },
          onClick: _cache[9] || (_cache[9] = $event => $setup.uploadInstallPopoverVisible = false)
        })]), _createVNode(_component_el_upload, {
          "on-exceed": $setup.handleInstallExceed,
          class: "upload-pane",
          drag: "",
          ref: "uploadInstallPane",
          action: $setup.uploadInstallData.signatureData.host,
          "before-upload": $setup.handleInstallBeforeUpload,
          "on-success": $setup.handleInstallOnSuccess,
          data: $setup.uploadInstallData.data,
          limit: 1,
          "file-list": $setup.uploadInstallData.fileList
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_a_button, {
            class: "sts-button default",
            color: "#539ce0",
            style: {
              "width": "100px",
              "margin": "5px 0px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.browse")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createVNode(_component_svg_icon, {
            iconName: "Excel",
            iconSize: "18px"
          }), _createVNode(_component_svg_icon, {
            iconName: "upload",
            iconSize: "18px"
          })]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("installConvey.uploadHint")), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("installConvey.supported")) + "-xls/xlsx-" + _toDisplayString(_ctx.$t("installConvey.fileType")), 1)])])])]),
          _: 1
        }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
        _: 1
      }, 8, ["visible"]), $setup.permission.havePermission('安装及发货进度', '安装进度导出') ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "sts-button default",
        color: "black",
        style: {
          "margin-left": "15px"
        },
        onClick: $setup.openInstallationEvent
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.export")), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), $setup.tokenData.type === 2 ? (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        class: "sts-button default",
        color: "black",
        style: {
          "margin-left": "15px"
        },
        onClick: $setup.changeReport
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($setup.deliveredControl.isOpenReport == false ? _ctx.$t("installConvey.report") : _ctx.$t("installConvey.confirmReport")), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_27, [_createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("installConvey.totalProgress")), 1), _createVNode(_component_a_progress, {
        "stroke-color": {
          '0%': '#447ae2',
          '100%': '#29abe2'
        },
        percent: $setup.installConveyData.install.percentage,
        style: {
          "width": "190px",
          "height": "15px"
        },
        trailColor: "#f0f0f0"
      }, null, 8, ["percent"])])])]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_vxe_table, {
        size: "medium",
        class: "column-sort",
        ref: "installTable",
        height: "auto",
        stripe: "",
        data: $setup.installationData.data,
        "row-config": {
          useKey: true,
          keyField: 'storeCode'
        },
        loading: $setup.installLoading,
        "loading-config": {
          icon: 'vxe-icon-indicator roll',
          text: ' '
        },
        "column-config": {
          useKey: true
        },
        "sort-config": {
          showIcon: false
        },
        onHeaderCellClick: $setup.headerCellInstallClickEvent,
        onScroll: $setup.installTableScroll,
        "expand-config": $setup.expandConfig,
        "row-class-name": $setup.rowClassName,
        "checkbox-config": {
          reserve: true,
          checkRowKeys: $setup.reportChecks
        },
        onCheckboxChange: $setup.onCheckboxChange,
        onCheckboxAll: $setup.onCheckboxAll
      }, {
        default: _withCtx(() => [$setup.deliveredControl.isOpenReport == true ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 0,
          type: "checkbox"
        })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          field: "storeName",
          type: "expand",
          title: _ctx.$t('installConvey.storeName'),
          "min-width": !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 350 : 450,
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.storeName), 1)]),
          content: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_vxe_table, {
            style: {
              "max-width": "100%"
            },
            "show-header": false,
            data: row.storeLocations
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_column, {
              width: "100",
              field: "installationStatusNameZh"
            }), $setup.vendorId == '' && $setup.tokenData.type === 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
              key: 0,
              width: "50",
              field: "vendorName"
            })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
              width: "50",
              field: "storeFloor"
            }), _createVNode(_component_vxe_column, {
              width: "150",
              field: "category"
            }), _createVNode(_component_vxe_column, {
              width: "100",
              field: "region"
            }), _createVNode(_component_vxe_column, {
              width: "100",
              field: "gender"
            }), _createVNode(_component_vxe_column, {
              width: "200",
              field: "supportType"
            }), _createVNode(_component_vxe_column, {
              width: "60",
              field: "ice"
            }), _createVNode(_component_vxe_column, {
              width: "100",
              field: "location"
            }), _createVNode(_component_vxe_column, {
              width: "200",
              field: "locationSummary"
            }), _createVNode(_component_vxe_column, {
              width: "200",
              field: "locationDescription"
            }), _createVNode(_component_vxe_column, {
              width: "170"
            }, {
              default: _withCtx(({
                row: subRow
              }) => [_createElementVNode("div", _hoisted_32, [subRow.installationStatusId == 1 && $setup.tokenData.type == 2 && $setup.tokenData.managerId == subRow.vendorId ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                onClick: $event => $setup.selfActivityInstallation(row, subRow),
                class: "sts-button default",
                style: {
                  "height": "28px",
                  "padding": "0",
                  "width": "50px"
                }
              }, {
                default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.selfInstall")), 1)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["data"])])])]),
          _: 1
        }, 8, ["title", "min-width"]), _createVNode(_component_vxe_column, {
          field: "storeTypeId",
          title: _ctx.$t('installConvey.storeType'),
          width: !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 150 : 250,
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.storeTypeNameZh), 1)]),
          _: 1
        }, 8, ["title", "width"]), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 1,
          field: "vendorName",
          title: _ctx.$t('installConvey.supplier'),
          width: !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 100 : 200,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: false,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", null, _toDisplayString(row.vendorName), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.supplierInfo")), 1), _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyVendor(row)
            }, null, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.activityInstallations, (install, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.contact")) + "：", 1), _createElementVNode("p", null, _toDisplayString(install.installationResponsibleName), 1)]), _createElementVNode("div", _hoisted_37, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.phone")) + "：", 1), _createElementVNode("p", null, _toDisplayString(install.phoneNumber), 1)])]);
            }), 128))])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
          _: 1
        }, 8, ["title", "width"])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 2,
          field: "vendorTypeId",
          title: _ctx.$t('installConvey.serviceContent'),
          "min-width": "100",
          width: 100,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.vendorTypeNameZh), 1)]),
          _: 1
        }, 8, ["title"])) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          field: "city",
          title: _ctx.$t('installConvey.city'),
          "min-width": "100",
          width: 100,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          _: 1
        }, 8, ["title"]), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 3,
          field: "installationStatusId",
          title: _ctx.$t('installConvey.staffAcceptStatus'),
          width: "150",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [row.installationStatusId === 5 ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: true,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_createElementVNode("span", null, _toDisplayString(row.installationStatusNameZh), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.acceptanceInfo")), 1), _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyResult(row)
            }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.contact")), 1), _createElementVNode("p", null, _toDisplayString(row.installationResultContactName ? row.installationResultContactName : _ctx.$t("installConvey.noData")), 1)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.phone")) + "：", 1), _createElementVNode("p", null, _toDisplayString(row.installationResultContactMobile), 1)]), _createElementVNode("div", _hoisted_44, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.signatureImage")) + "：", 1), _createElementVNode("div", _hoisted_45, [_createVNode(_component_el_image, {
              src: row.installationAcceptanceSign ? row.installationAcceptanceSign : row.uploadedName,
              alt: "",
              style: {
                "width": "100%",
                "border": "1px solid red",
                "height": "200px",
                "background": "#fff"
              }
            }, null, 8, ["src"])])])])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])) : (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("span", null, _toDisplayString(row.installationStatusNameZh), 1)])]))]),
          _: 1
        }, 8, ["title"])) : _createCommentVNode("", true), $setup.vendorId == '' && $setup.tokenData.type === 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 4,
          field: "installationConfirmStatusNameCn",
          title: _ctx.$t('installConvey.installProgress'),
          width: "200",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", null, _toDisplayString(row.installationProgress) + "%", 1), _createVNode(_component_el_progress, {
            style: {
              "width": "118px"
            },
            "show-text": false,
            "stroke-width": 6,
            percentage: row.installationProgress,
            color: "black"
          }, null, 8, ["percentage"])])]),
          _: 1
        }, 8, ["title"])) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          field: "",
          title: _ctx.$t('installConvey.installPhoto'),
          width: !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 120 : 250,
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1)]),
          default: _withCtx(({
            row
          }) => [row.imageUrl != null ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onClick: $event => $setup.installUploadClick(row),
            style: {
              "color": "#0763db",
              "cursor": "pointer",
              "font-weight": "400"
            }
          }, _toDisplayString(_ctx.$t("installConvey.view")), 9, _hoisted_49)) : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t("installConvey.view")), 1))]),
          _: 1
        }, 8, ["title", "width"]), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 5,
          field: "installationConfirmStatusNameCn",
          title: _ctx.$t('installConvey.supplierAuditStatus'),
          width: "150",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.installationConfirmStatusNameCn), 1)]),
          _: 1
        }, 8, ["title"])) : _createCommentVNode("", true), $setup.vendorId == '' && $setup.tokenData.type === 1 ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 6,
          field: "installationConfirmStatusNameCn",
          title: _ctx.$t('installConvey.auditStatus'),
          sortable: "",
          "min-width": "120"
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          _: 1
        }, 8, ["title"])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 7,
          field: "",
          title: _ctx.$t('installConvey.appointmentStatus'),
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.installationDate ? _ctx.$t("installConvey.appointed") : _ctx.$t("installConvey.unappointed")), 1)]),
          _: 1
        }, 8, ["title"])) : _createCommentVNode("", true), !($setup.vendorId == '' && $setup.tokenData.type === 1) ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 8,
          field: "installationDate",
          title: _ctx.$t('installConvey.appointmentTime'),
          "min-width": "200",
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.installationDate ? $setup.getDate(row.installationDate) : _ctx.$t("installConvey.unappointed")), 1)]),
          _: 1
        }, 8, ["title"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data", "loading", "onHeaderCellClick", "onScroll", "expand-config", "row-class-name", "checkbox-config", "onCheckboxChange", "onCheckboxAll"])]), _createElementVNode("div", _hoisted_51, [_createVNode(_component_vxe_pager, {
        class: "sts-pager",
        background: "",
        "page-size": $setup.installPaginationData.pageSize,
        "onUpdate:pageSize": _cache[10] || (_cache[10] = $event => $setup.installPaginationData.pageSize = $event),
        "current-page": $setup.installPaginationData.currentPage,
        "onUpdate:currentPage": _cache[11] || (_cache[11] = $event => $setup.installPaginationData.currentPage = $event),
        "pager-count": 5,
        total: $setup.installPaginationData.totalSize,
        "page-sizes": $setup.installPaginationData.pageSizes,
        layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
        onPageChange: $setup.paginationCurrentInstallChange
      }, null, 8, ["page-size", "current-page", "total", "page-sizes", "onPageChange"])])])]),
      _: 1
    }, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
      key: "second",
      tab: _ctx.$t('installConvey.deliveryProgress')
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.storeType,
        "onUpdate:value": _cache[12] || (_cache[12] = $event => $setup.conveyQuery.insSelect.storeType = $event),
        placeholder: _ctx.$t('installConvey.selectStoreType'),
        size: "medium",
        onChange: _cache[13] || (_cache[13] = $event => $setup.searchConverClick(1)),
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeTypeLogisticsData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.storeTypeId,
            value: item.storeTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.storeTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "placeholder"])]), _createElementVNode("div", _hoisted_58, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.state,
        "onUpdate:value": _cache[14] || (_cache[14] = $event => $setup.conveyQuery.insSelect.state = $event),
        placeholder: _ctx.$t('installConvey.selectLogisticsStatus'),
        size: "medium",
        onChange: $setup.searchConverClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [_createVNode(_component_a_select_option, {
          value: "0"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("installConvey.inTransit")), 1)]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "3"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("installConvey.signed")), 1)]),
          _: 1
        }), _createVNode(_component_a_select_option, {
          value: "4"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("installConvey.problematic")), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["value", "placeholder", "onChange"])]), _createElementVNode("div", _hoisted_59, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.logisticsTypeId,
        "onUpdate:value": _cache[15] || (_cache[15] = $event => $setup.conveyQuery.insSelect.logisticsTypeId = $event),
        placeholder: _ctx.$t('installConvey.selectLogisticsType'),
        size: "medium",
        onChange: $setup.searchConverClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.logisticsTypeData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.logisticsTypeId,
            value: item.logisticsTypeId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.logisticsTypeNameZh), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "placeholder", "onChange"])]), _createElementVNode("div", _hoisted_60, [_createVNode(_component_a_select, {
        disabled: $setup.vendorId.length > 0,
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.vendorId,
        "onUpdate:value": _cache[16] || (_cache[16] = $event => $setup.conveyQuery.insSelect.vendorId = $event),
        placeholder: _ctx.$t('installConvey.selectSupplier'),
        size: "medium",
        onChange: $setup.searchConverClick,
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vendorData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item.vendorId,
            value: item.vendorId
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorName), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["disabled", "value", "placeholder", "onChange"])]), _createElementVNode("div", _hoisted_61, [_createVNode(_component_a_select, {
        filterable: "",
        allowClear: "",
        value: $setup.conveyQuery.insSelect.areaInput,
        "onUpdate:value": _cache[17] || (_cache[17] = $event => $setup.conveyQuery.insSelect.areaInput = $event),
        placeholder: _ctx.$t('installConvey.selectCity'),
        size: "medium",
        onChange: _cache[18] || (_cache[18] = $event => $setup.searchConverClick(2)),
        style: {
          "width": "150px"
        }
      }, {
        suffixIcon: _withCtx(() => [_createVNode(_component_down_circle_outlined, {
          class: "ant-select-suffix",
          style: {
            "color": "#818181"
          }
        })]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cityData, item => {
          return _openBlock(), _createBlock(_component_a_select_option, {
            key: item,
            value: item
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["value"]);
        }), 128))]),
        _: 1
      }, 8, ["value", "placeholder"])])]), _createElementVNode("div", null, [_createVNode(_component_a_input_search, {
        value: $setup.conveyQuery.insValue,
        "onUpdate:value": _cache[19] || (_cache[19] = $event => $setup.conveyQuery.insValue = $event),
        placeholder: _ctx.$t('installConvey.searchContent'),
        style: {
          "width": "264px"
        },
        onSearch: $setup.searchConverClick
      }, null, 8, ["value", "placeholder", "onSearch"])])])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
        visible: $setup.uploadConverPopoverVisible,
        placement: "bottom",
        trigger: "click",
        width: "auto",
        teleported: false,
        "popper-class": "upload-box-popper"
      }, {
        reference: _withCtx(() => [$setup.permission.havePermission('安装及发货进度', '物流表上传') ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          class: "sts-button default",
          color: "black",
          onClick: $setup.openUploadConverPopover,
          style: {
            "margin-right": "15px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.logisticsUpload")), 1)]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("installConvey.logisticsUpload")), 1), _createVNode(_component_svg_icon, {
          iconName: "close",
          iconColor: 'black',
          iconSize: "15px",
          style: {
            "cursor": "pointer",
            "padding": "3px"
          },
          onClick: _cache[20] || (_cache[20] = $event => $setup.uploadConverPopoverVisible = false)
        })]), _createVNode(_component_el_upload, {
          "on-exceed": $setup.handleConverExceed,
          class: "upload-pane",
          drag: "",
          ref: "uploadConverPane",
          action: $setup.uploadConverData.signatureData.host,
          "before-upload": $setup.handleConverBeforeUpload,
          "on-success": $setup.handleConverOnSuccess,
          data: $setup.uploadConverData.data,
          limit: 1,
          "file-list": $setup.uploadConverData.fileList
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_66, [_createVNode(_component_a_button, {
            class: "sts-button default",
            color: "#539ce0",
            style: {
              "width": "100px",
              "margin": "5px 0px"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.browse")), 1)]),
            _: 1
          }), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createVNode(_component_svg_icon, {
            iconName: "Excel",
            iconSize: "18px"
          }), _createVNode(_component_svg_icon, {
            iconName: "upload",
            iconSize: "18px"
          })]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", null, _toDisplayString(_ctx.$t("installConvey.uploadHint")), 1), _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.$t("installConvey.supported")) + "-xls/xlsx-" + _toDisplayString(_ctx.$t("installConvey.fileType")), 1)])])])]),
          _: 1
        }, 8, ["on-exceed", "action", "before-upload", "on-success", "data", "file-list"])])]),
        _: 1
      }, 8, ["visible"]), $setup.permission.havePermission('安装及发货进度', '物流表导出') ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        class: "sts-button default",
        color: "black",
        style: {
          "margin-right": "15px"
        },
        onClick: $setup.openExportEvent
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.export")), 1)]),
        _: 1
      }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_a_button, {
        class: "sts-button default",
        color: "black",
        style: {
          "margin-right": "15px"
        },
        onClick: $setup.batchDeliveredLogistics
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($setup.deliveredControl.isOpenBatch == false ? _ctx.$t("installConvey.batchDelivery") : _ctx.$t("installConvey.confirmDelivery")), 1)]),
        _: 1
      }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_71, [_createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t("installConvey.totalProgress")), 1), _createVNode(_component_a_progress, {
        "stroke-color": {
          '0%': '#447ae2',
          '100%': '#29abe2'
        },
        percent: $setup.installConveyData.convey.percentage,
        style: {
          "width": "190px",
          "height": "15px"
        },
        trailColor: "#f0f0f0"
      }, null, 8, ["percent"])])])]), _createElementVNode("div", _hoisted_73, [_createVNode(_component_vxe_table, {
        size: "medium",
        class: "column-sort",
        ref: "conveyTable",
        stripe: "",
        "export-config": {},
        height: "auto",
        data: $setup.conveyData.data,
        "row-config": {
          useKey: true
        },
        loading: $setup.conveyLoading,
        "loading-config": {
          icon: 'vxe-icon-indicator roll',
          text: ' '
        },
        "column-config": {
          useKey: true
        },
        "sort-config": {
          showIcon: false
        },
        onHeaderCellClick: $setup.headerCellConverClickEvent,
        onScroll: $setup.conveyTableScroll,
        "checkbox-config": $setup.checkboxConfig
      }, {
        default: _withCtx(() => [_createTextVNode(" > "), $setup.deliveredControl.isOpenBatch == true ? (_openBlock(), _createBlock(_component_vxe_column, {
          key: 0,
          type: "checkbox"
        })) : _createCommentVNode("", true), _createVNode(_component_vxe_column, {
          field: "storeName",
          title: _ctx.$t('installConvey.storeName'),
          "min-width": !($setup.vendorId == '' && $setup.tokenData.type === 1) ? 350 : 450,
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", _hoisted_74, _toDisplayString(row.storeName), 1)]),
          _: 1
        }, 8, ["title", "min-width"]), _createVNode(_component_vxe_column, {
          field: "storeTypeId",
          title: _ctx.$t('installConvey.storeType'),
          width: "200",
          sortable: "",
          "show-overflow": ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.storeTypeNameZh), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          field: "vendorName",
          title: _ctx.$t('installConvey.supplier'),
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: false,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_75, [_createElementVNode("span", null, _toDisplayString(row.vendorName), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.supplierInfo")), 1), _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyVendor(row)
            }, null, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.activityInstallations, (install, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index
              }, [_createElementVNode("div", _hoisted_78, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.contact")) + "：", 1), _createElementVNode("p", null, _toDisplayString(install.installationResponsibleName), 1)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.phone")) + "：", 1), _createElementVNode("p", null, _toDisplayString(install.phoneNumber), 1)])]);
            }), 128))])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          field: "vendorTypeId",
          title: _ctx.$t('installConvey.serviceContent'),
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createTextVNode(_toDisplayString(row.vendorTypeNameZh), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          field: "city",
          title: _ctx.$t('installConvey.city'),
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          field: "logisticsTypeNameZh",
          title: _ctx.$t('installConvey.logisticsType'),
          width: "100",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("span", null, _toDisplayString(row.logisticsTypeNameZh), 1)]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          field: "logisticsOrderCode",
          title: _ctx.$t('installConvey.logisticsInfo'),
          "min-width": "180",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: true,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_80, [_createElementVNode("span", null, _toDisplayString(row.logisticsOrderCode), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "Tips",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_81, [_createElementVNode("div", _hoisted_82, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.receivingInfo")), 1), _createVNode(_component_svg_icon, {
              iconName: "copy",
              iconSize: "18px",
              onClick: $event => $setup.copyVendor(row)
            }, null, 8, ["onClick"])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.contact")) + "：", 1), _createElementVNode("p", null, _toDisplayString(row.contacts), 1)]), _createElementVNode("div", _hoisted_84, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.phone")) + "：", 1), _createElementVNode("p", null, _toDisplayString(row.phoneNumber), 1)]), row.logisticsTypeNameZh !== '物流' ? (_openBlock(), _createElementBlock("div", _hoisted_85, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("installConvey.licensePlate")) + "：", 1), _createElementVNode("p", null, _toDisplayString(row.logisticsOrderCode), 1)])) : _createCommentVNode("", true)])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])])]),
          _: 1
        }, 8, ["title"]), _createVNode(_component_vxe_column, {
          field: "expressStateName",
          title: _ctx.$t('installConvey.logisticsStatus'),
          "min-width": "150",
          sortable: ""
        }, {
          header: _withCtx(({
            column
          }) => [_createElementVNode("span", null, _toDisplayString(column.title), 1), column.order == 'asc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            iconName: "sortup",
            iconSize: "24px"
          })) : column.order == 'desc' ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 1,
            iconName: "sortdown",
            iconSize: "24px"
          })) : (_openBlock(), _createBlock(_component_svg_icon, {
            key: 2,
            iconName: "sort2",
            iconSize: "24px"
          }))]),
          default: _withCtx(({
            row
          }) => [row.logisticsTypeNameZh === '物流' ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createElementVNode("div", {
            onClick: $event => $setup.onExpressInfoOpen(row),
            class: "TipsBox"
          }, [row.expressStateId.substring(0, 1) === '3' ? (_openBlock(), _createElementBlock("span", _hoisted_88, _toDisplayString(_ctx.$t("installConvey.signed")), 1)) : _createCommentVNode("", true), row.expressStateId.substring(0, 1) === '4' ? (_openBlock(), _createElementBlock("span", _hoisted_89, _toDisplayString(_ctx.$t("installConvey.problematic")), 1)) : _createCommentVNode("", true), row.expressStateId.substring(0, 1) !== '3' && row.expressStateId.substring(0, 1) !== '4' ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(_ctx.$t("installConvey.inTransit")), 1)) : _createCommentVNode("", true), _createVNode(_component_svg_icon, {
            class: "tip",
            iconName: "unfold",
            iconSize: "15px",
            style: {
              "cursor": "pointer"
            }
          })], 8, _hoisted_87)])) : (_openBlock(), _createElementBlock("div", _hoisted_91, [row.expressStateName !== '已签收' && ($setup.tokenData.type === 1 || $setup.tokenData.type === 2 && $setup.tokenData.managerId === row.vendorId) ? (_openBlock(), _createBlock(_component_el_popover, {
            key: 0,
            modelValue: row.popoverVisible,
            "onUpdate:modelValue": $event => row.popoverVisible = $event,
            placement: "bottom",
            trigger: "click",
            "popper-style": "min-width: 0px;width: auto;background:#f3f3f3",
            teleported: true,
            "show-arrow": false
          }, {
            reference: _withCtx(() => [_createElementVNode("div", _hoisted_92, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.inTransit")), 1), _createVNode(_component_el_link, {
              underline: false
            }, {
              default: _withCtx(() => [_createVNode(_component_svg_icon, {
                class: "tip",
                iconName: "unfold",
                iconSize: "15px"
              })]),
              _: 1
            })])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_93, [_createVNode(_component_a_button, {
              class: "sts-button default",
              color: "black",
              style: {
                "margin": "5px 0"
              },
              onClick: $event => $setup.deliveredLogistics(row)
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.delivered")), 1)]),
              _: 2
            }, 1032, ["onClick"])])]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true), row.expressStateName == '已签收' ? (_openBlock(), _createElementBlock("div", _hoisted_94, _toDisplayString(_ctx.$t("installConvey.delivered")), 1)) : _createCommentVNode("", true)]))]),
          _: 1
        }, 8, ["title"])]),
        _: 1
      }, 8, ["data", "loading", "onHeaderCellClick", "onScroll", "checkbox-config"])]), _createElementVNode("div", _hoisted_95, [_createVNode(_component_vxe_pager, {
        class: "sts-pager",
        background: "",
        "page-size": $setup.conveyPaginationData.pageSize,
        "onUpdate:pageSize": _cache[21] || (_cache[21] = $event => $setup.conveyPaginationData.pageSize = $event),
        "current-page": $setup.conveyPaginationData.currentPage,
        "onUpdate:currentPage": _cache[22] || (_cache[22] = $event => $setup.conveyPaginationData.currentPage = $event),
        "pager-count": 5,
        total: $setup.conveyPaginationData.totalSize,
        "page-sizes": $setup.conveyPaginationData.pageSizes,
        layouts: ['PrevJump', 'JumpNumber', 'NextJump', 'Sizes', 'FullJump', 'Total'],
        onPageChange: $setup.paginationCurrentConverChange
      }, null, 8, ["page-size", "current-page", "total", "page-sizes", "onPageChange"])])])]),
      _: 1
    }, 8, ["tab"])]),
    _: 1
  }, 8, ["activeKey"])])]), _createVNode(_component_ex_dialog, {
    extraStyle: "min-width: 380px;\n    max-width: 600px;\n    width: 80%;\n    height: 400px;\n    font-size: 14px;\n    padding:10px",
    isVisible: $setup.importMessage.importMessageVisible
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.$t("installConvey.importValidationError")), 1), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_97, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.importMessage.importMessages, (message, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index
      }, _toDisplayString(message), 1);
    }), 128))]), _createElementVNode("div", _hoisted_98, [_createVNode(_component_a_button, {
      onClick: _cache[24] || (_cache[24] = $event => $setup.importMessage.importMessageVisible = false),
      style: {
        "border-color": "black",
        "color": "black"
      },
      class: "sts-button default"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t("installConvey.close")), 1)]),
      _: 1
    })])]),
    _: 1
  }, 8, ["isVisible"]), _createVNode(_component_a_config_provider, {
    theme: {
      components: {
        Modal: {
          paddingContentHorizontalLG: 12,
          paddingMD: 12
        }
      }
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_a_modal, {
      open: $setup.expressInfoOpen,
      "onUpdate:open": _cache[25] || (_cache[25] = $event => $setup.expressInfoOpen = $event),
      closable: false,
      width: "704px",
      zIndex: 1001,
      centered: true,
      footer: null,
      title: null
    }, {
      default: _withCtx(() => [_createVNode(_component_svg_icon, {
        onClick: $setup.onExpressInfoClose,
        class: "tip",
        iconName: "close_circle",
        iconSize: "20px",
        iconColor: '#ffffff',
        style: {
          "cursor": "pointer",
          "position": "absolute",
          "top": "-20px",
          "right": "-40px"
        }
      }, null, 8, ["onClick"]), _createElementVNode("div", _hoisted_99, [$setup.currentExpress && $setup.currentExpress.expressCoordinates != null && $setup.currentExpress.expressCoordinates.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_100)) : _createCommentVNode("", true), $setup.currentExpress && $setup.currentExpress.expressCoordinates != null && $setup.currentExpress.expressCoordinates.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_101)) : _createCommentVNode("", true), $setup.currentExpress ? (_openBlock(), _createElementBlock("div", _hoisted_102, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentExpress.expressTraces.slice().reverse(), (x, index) => {
        return _openBlock(), _createElementBlock("div", {
          style: {
            "display": "flex",
            "color": "#777777"
          },
          key: index
        }, [_createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, _toDisplayString(x.expressTraceAcceptTime), 1), _createElementVNode("div", _hoisted_105, [_createElementVNode("div", _hoisted_106, [index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_107, [_createVNode(_component_svg_icon, {
          iconName: "confirm",
          iconColor: 'red',
          iconSize: "12px"
        })])) : _createCommentVNode("", true), index !== 0 ? (_openBlock(), _createElementBlock("div", _hoisted_108, _hoisted_110)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_111, [index === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString($setup.currentExpress.expressStateName), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(x.expressTraceAcceptStation), 1)])])]);
      }), 128))])) : _createCommentVNode("", true)])]),
      _: 1
    }, 8, ["open"])]),
    _: 1
  })], 64);
}